import { render, staticRenderFns } from "./chateau-lafite-rothschild.vue?vue&type=template&id=f4820e12&scoped=true"
import script from "./chateau-lafite-rothschild.vue?vue&type=script&lang=js"
export * from "./chateau-lafite-rothschild.vue?vue&type=script&lang=js"
import style0 from "./chateau-lafite-rothschild.vue?vue&type=style&index=0&id=f4820e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4820e12",
  null
  
)

export default component.exports